const BANK_TYPES = {
  BANMET: 'BANMET',
  BPA: 'BPA',
  BANDEC: 'BANDEC',
};

const BANK_CODES = {
  BANMET: '05',
  BPA: '12',
  BANDEC: '06',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const BANK_TYPES_ENUM = Object.keys(BANK_TYPES);

const BANMET = BANK_TYPES_ENUM[0];
const BPA = BANK_TYPES_ENUM[1];
const BANDEC = BANK_TYPES_ENUM[2];

const BANK_TYPES_INFO_ENUM = [
  {
    code: '05',
    type: BANK_TYPES.BANMET,
    label: 'Banco Metropolitano S.A. (BANMET)',
    isVisible: (prov) => prov === 'HAB',
  },
  {
    code: '12',
    type: BANK_TYPES.BPA,
    label: 'Banco Popular de Ahorro (BPA)',
    isVisible: () => true,
  },
  {
    code: '06',
    type: BANK_TYPES.BANDEC,
    label: 'Banco de Crédito y Comercio de Cuba (BANDEC)',
    isVisible: () => true,
  },
];

const BANK_TYPES_INFO = BANK_TYPES_INFO_ENUM.reduce((r, e) => {
  r[e.type] = e;
  return r;
}, {});

export {
  BANMET,
  BPA,
  BANDEC,
  BANK_TYPES_ENUM,
  BANK_CODES,
  BANK_TYPES,
  BANK_TYPES_INFO,
  BANK_TYPES_INFO_ENUM,
};
